<template>
	<div class="deprecation-overlay d-flex align-center justify-center appGrey">

		<div class="d-flex flex-column align-center pa-4" style="min-width: 256px; width: 100%; max-width: 512px">

			<!--Logo-->
			<div class="d-flex justify-center">
				<v-img :src="require('@/assets/images/company-logo.svg')"
					   style="min-width: 256px; width: 100%; max-width: 256px"/>
			</div>

			<v-divider class="mt-8" style="width: 100%"/>

			<app-text class="text-center mt-8" color="primary" size="medium-bold">
				This platform has been replaced by a new version.
			</app-text>

			<app-text class="text-center mt-4">
				You'll receive instructions on how to access SWAPP3 later this month.
			</app-text>

			<app-text class="text-center mt-4">
				If you have any questions in the meantime, please contact your administrator.
			</app-text>

		</div>

	</div>
</template>

<script>
export default {
	name: "DeprecationBanner"
}
</script>

<style scoped>
.deprecation-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 9999;
}
</style>
